import React from 'react';

// About page content from the previous drive.day/about-us page
function HeroAbout() {
    return (
        <>
            <div className="dd-about-top-title-area">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-9">
                            <div className="dd-about-top-title">
                                <h2 className="title">About us</h2>
                                <p>
                                    Drive.Day is built by a team that loves creating useful, real-world
                                    software. We believe the best products are shaped by the people who
                                    use them, so instructor feedback is at the heart of everything we
                                    do. If you have an idea or a question, please get in touch.
                                </p>
                                <p>
                                    Our development team brings 20 years of experience building apps,
                                    including helping to build the first version of a very popular
                                    babysitting booking app and working at Booking.com. That background
                                    in booking platforms and in handling personal data responsibly is
                                    exactly what running a driving school&rsquo;s diary, pupils and
                                    payments demands.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <section className="dd-about-page-area">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8">
                            <div className="dd-about-page-content">
                                <h3 className="title">Our Journey</h3>
                                <p>
                                    We built the first version of Drive.Day in 2024. Before launching, we
                                    took it to the Intelligent Instructor Conference to listen, learn and
                                    make sure we were solving the right problems. The feedback was
                                    invaluable: parts of that first build were hard to use. So we went
                                    back to first principles and rebuilt the app from the ground up,
                                    guided by what instructors told us. The conference became our live
                                    usability lab, and the result is a product shaped by the people who
                                    use it.
                                </p>
                                <p>
                                    We returned to the next Intelligent Instructor Conference with the
                                    rebuild in progress, gathered more practical feedback, made key
                                    changes and kept building with clarity and purpose.
                                </p>
                                <p>
                                    Drive.Day is now live, and we keep improving it with every release.
                                    We&rsquo;re excited to hear what you think, and we move quickly to fix
                                    any issues that come up in the real world.
                                </p>
                                <p>
                                    Thank you to everyone who has shared feedback, tested early versions
                                    and helped us at conferences along the way. You have helped shape
                                    Drive.Day.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default HeroAbout;
